import apiClient from '@/utils/api-client-without-base-url';

export default {
  delete: ({ id: optionId, variationId }) => {
    return apiClient.delete(`variations/${variationId}/options/${optionId}`);
  },
  create: (option, variationId) => {
    return apiClient.post(`variations/${variationId}/options`, option);
  },
  edit: option => {
    const { variationId, id: optionId } = option;
    return apiClient.put(`variations/${variationId}/options/${optionId}`, option);
  }
};
